import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { useMarket } from "#/contexts/MarketContext";
import {
  useGetBlModifiedAvailableFiles,
  useSearchBlModifiedOrders,
} from "#/lib/api/bl-modified";
import { BlModifiedOrderSearchSchema } from "#/lib/schemas/bl-modified-search";
import { BlModifiedPage } from "#/components/pages/bl-modified/bl-modified-page";

export const Route = createFileRoute("/$tenantCode/$market/bl-modified")({
  validateSearch: BlModifiedOrderSearchSchema,
  beforeLoad: () => ({ getTitle: () => m["resources.blModified.name"]() }),
  component: BlModifiedRoute,
});

function BlModifiedRoute() {
  const market = useMarket();
  const { page, perPage, sort } = Route.useSearch();

  const { data, isLoading } = useSearchBlModifiedOrders({
    page,
    limit: perPage,
    sort,
    market,
  });

  const { data: availableFiles } = useGetBlModifiedAvailableFiles({ market });

  const orders = data?.data ?? [];
  const totalItems = data?.meta?.totalItems ?? 0;
  const totalPages = data?.meta?.totalPages ?? 0;

  return (
    <BlModifiedPage
      orders={orders}
      totalItems={totalItems}
      pageCount={totalPages}
      isLoading={isLoading}
      market={market}
      availableFiles={availableFiles}
    />
  );
}
